<div class="flex flex-col gap-2">
  <p-tabs [value]="1">
    <p-tablist>
      @for(round of rounds; track $index) {
        <p-tab [value]="$index + 1">R{{ $index + 1 }}</p-tab>
      }
      @if(playoffs.ROUND_OF_16) {
        <p-tab value="R16">{{ 'tournament-phases.round_of_16' | translate }}</p-tab> 
      }
      @if(playoffs.QUARTERFINALS) {
        <p-tab value="QF">{{ 'tournament-phases.quarterfinals' | translate }}</p-tab> 
      }
      @if(playoffs.SEMIFINALS) {
        <p-tab value="SF">{{ 'tournament-phases.semifinals' | translate }}</p-tab> 
      }
      @if(playoffs.FINAL) {
        <p-tab value="F">{{ 'tournament-phases.final' | translate }}</p-tab> 
      }
    </p-tablist>
    <p-tabpanels>
      <!-- ROUNDS -->
      @for(round of rounds; track $index) {
        <p-tabpanel [value]="$index + 1">
          <div class="round flex flex-col gap-4">
            <div class="round-title">{{ 'tournament-phases.round' | translate }} {{round.round}}</div>
            @for(group of round!.groups; track $index) {
              <div class="group flex flex-col gap-4">
                <div class="group-name">{{ group.group.name }}</div>
                @for(match of group.matches; track $index) {
                  <div class="match">
                    <div class="table-number">{{ match.tableNumber ? 'M' + match.tableNumber : '-' }}</div>
                    <div class="whites" [ngClass]="{'winner': match.black.points < match.white.points}">
                      {{match.white.name === 'TBD' ? '-' : match.white.name}}
                    </div>
                    <div class="points">
                      <div>{{match.white.points}}</div>
                      <div>{{match.black.points}}</div>
                    </div>
                    <div class="blacks" [ngClass]="{'winner': match.black.points > match.white.points}">
                      {{match.black.name === 'TBD' ? '-' : match.black.name}}
                    </div>
                  </div>
                }
              </div>
              @if($index + 1 !== round!.groups.length) {
                <hr>
              }
            }
          </div>
        </p-tabpanel>
      }
      <!-- ROUND_OF_16 -->
      @if(playoffs.ROUND_OF_16) {
        <p-tabpanel value="R16">
          <div class="round flex flex-col gap-4">
            <div class="round-title">{{ 'tournament-phases.round_of_16' | translate }}</div>
            <div class="matches flex flex-col gap-4">
              @for(match of playoffs.ROUND_OF_16?.official; track $index) {
                <div class="match">
                  <div class="table-number">{{ match.tableNumber ? 'M' + match.tableNumber : '-' }}</div>
                  <div class="whites" [ngClass]="{'winner': match.black.points < match.white.points}">
                    {{match.white.name === 'TBD' ? '-' : match.white.name}}
                  </div>
                  <div class="points">
                    <div>{{match.white.points}}</div>
                    <div>{{match.black.points}}</div>
                  </div>
                  <div class="blacks" [ngClass]="{'winner': match.black.points > match.white.points}">
                    {{match.black.name === 'TBD' ? '-' : match.black.name}}
                  </div>
                </div>
              }
            </div>
            @if(playoffs.ROUND_OF_16?.consolation?.length) {
              <hr>
              <div class="matches flex flex-col gap-4">
                <div class="matches-title">{{ 'consolation' | translate }}</div>
                @for(match of playoffs.ROUND_OF_16?.consolation; track $index) {
                  <div class="match">
                    <div class="table-number">{{ match.tableNumber ? 'M' + match.tableNumber : '-' }}</div>
                    <div class="whites" [ngClass]="{'winner': match.black.points < match.white.points}">
                      {{match.white.name === 'TBD' ? '-' : match.white.name}}
                    </div>
                    <div class="points">
                      <div>{{match.white.points}}</div>
                      <div>{{match.black.points}}</div>
                    </div>
                    <div class="blacks" [ngClass]="{'winner': match.black.points > match.white.points}">
                      {{match.black.name === 'TBD' ? '-' : match.black.name}}
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        </p-tabpanel>
      }
      <!-- QUARTERFINALS -->
      @if(playoffs.QUARTERFINALS) {
        <p-tabpanel value="QF">
          <div class="round flex flex-col gap-4">
            <div class="round-title">{{ 'tournament-phases.quarterfinals' | translate }}</div>
            <div class="matches flex flex-col gap-4">
              @for(match of playoffs.QUARTERFINALS?.official; track $index) {
                <div class="match">
                  <div class="table-number">{{ match.tableNumber ? 'M' + match.tableNumber : '-' }}</div>
                  <div class="whites" [ngClass]="{'winner': match.black.points < match.white.points}">
                    {{match.white.name === 'TBD' ? '-' : match.white.name}}
                  </div>
                  <div class="points">
                    <div>{{match.white.points}}</div>
                    <div>{{match.black.points}}</div>
                  </div>
                  <div class="blacks" [ngClass]="{'winner': match.black.points > match.white.points}">
                    {{match.black.name === 'TBD' ? '-' : match.black.name}}
                  </div>
                </div>
              }
            </div>
            @if(playoffs.QUARTERFINALS?.consolation?.length) {
              <hr>
              <div class="matches flex flex-col gap-4">
                <div class="matches-title">{{ 'consolation' | translate }}</div>
                @for(match of playoffs.QUARTERFINALS?.consolation; track $index) {
                  <div class="match">
                    <div class="table-number">{{ match.tableNumber ? 'M' + match.tableNumber : '-' }}</div>
                    <div class="whites" [ngClass]="{'winner': match.black.points < match.white.points}">
                      {{match.white.name === 'TBD' ? '-' : match.white.name}}
                    </div>
                    <div class="points">
                      <div>{{match.white.points}}</div>
                      <div>{{match.black.points}}</div>
                    </div>
                    <div class="blacks" [ngClass]="{'winner': match.black.points > match.white.points}">
                      {{match.black.name === 'TBD' ? '-' : match.black.name}}
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        </p-tabpanel>
      }
      <!-- SEMIFINALS -->
      @if(playoffs.SEMIFINALS) {
        <p-tabpanel value="SF">
          <div class="round flex flex-col gap-4">
            <div class="round-title">{{ 'tournament-phases.semifinals' | translate }}</div>
            <div class="matches flex flex-col gap-4">
              @for(match of playoffs.SEMIFINALS?.official; track $index) {
                <div class="match">
                  <div class="table-number">{{ match.tableNumber ? 'M' + match.tableNumber : '-' }}</div>
                  <div class="whites" [ngClass]="{'winner': match.black.points < match.white.points}">
                    {{match.white.name === 'TBD' ? '-' : match.white.name}}
                  </div>
                  <div class="points">
                    <div>{{match.white.points}}</div>
                    <div>{{match.black.points}}</div>
                  </div>
                  <div class="blacks" [ngClass]="{'winner': match.black.points > match.white.points}">
                    {{match.black.name === 'TBD' ? '-' : match.black.name}}
                  </div>
                </div>
              }
            </div>
            @if(playoffs.SEMIFINALS?.positioning?.length) {
              <hr>
              <div class="matches flex flex-col gap-4">
                <div class="matches-title">{{ 'positioning' | translate }}</div>
                @for(match of playoffs.SEMIFINALS?.positioning; track $index) {
                  <div class="match">
                    <div class="table-number">{{ match.tableNumber ? 'M' + match.tableNumber : '-' }}</div>
                    <div class="whites" [ngClass]="{'winner': match.black.points < match.white.points}">
                      {{match.white.name === 'TBD' ? '-' : match.white.name}}
                    </div>
                    <div class="points">
                      <div>{{match.white.points}}</div>
                      <div>{{match.black.points}}</div>
                    </div>
                    <div class="blacks" [ngClass]="{'winner': match.black.points > match.white.points}">
                      {{match.black.name === 'TBD' ? '-' : match.black.name}}
                    </div>
                  </div>
                }
              </div>
            }
            @if(playoffs.SEMIFINALS?.consolation?.length) {
              <hr>
              <div class="matches flex flex-col gap-4">
                <div class="matches-title">{{ 'consolation' | translate }}</div>
                @for(match of playoffs.SEMIFINALS?.consolation; track $index) {
                  <div class="match">
                    <div class="table-number">{{ match.tableNumber ? 'M' + match.tableNumber : '-' }}</div>
                    <div class="whites" [ngClass]="{'winner': match.black.points < match.white.points}">
                      {{match.white.name === 'TBD' ? '-' : match.white.name}}
                    </div>
                    <div class="points">
                      <div>{{match.white.points}}</div>
                      <div>{{match.black.points}}</div>
                    </div>
                    <div class="blacks" [ngClass]="{'winner': match.black.points > match.white.points}">
                      {{match.black.name === 'TBD' ? '-' : match.black.name}}
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        </p-tabpanel>
      }
      <!-- FINAL -->
      @if(playoffs.FINAL) {
        <p-tabpanel value="F">
          <div class="round flex flex-col gap-4">
            <div class="round-title">{{ 'tournament-phases.final' | translate }}</div>
            <div class="matches flex flex-col gap-4">
              @for(match of playoffs.FINAL?.official; track $index) {
                <div class="match">
                  <div class="table-number">{{ match.tableNumber ? 'M' + match.tableNumber : '-' }}</div>
                  <div class="whites" [ngClass]="{'winner': match.black.points < match.white.points}">
                    {{match.white.name === 'TBD' ? '-' : match.white.name}}
                  </div>
                  <div class="points">
                    <div>{{match.white.points}}</div>
                    <div>{{match.black.points}}</div>
                  </div>
                  <div class="blacks" [ngClass]="{'winner': match.black.points > match.white.points}">
                    {{match.black.name === 'TBD' ? '-' : match.black.name}}
                  </div>
                </div>
              }
            </div>
          </div>
        </p-tabpanel>
      }
    </p-tabpanels>
  </p-tabs>
</div>